/**
 * FAQ — accordion (expand/collapse answers) + "show more" reveal.
 */
export const faq = {
    init() {
        const roots = document.querySelectorAll('[data-faq]');
        if (!roots.length) return;

        roots.forEach((root) => {
            // Accordion: toggle each question's answer.
            root.querySelectorAll('.faq-question').forEach((btn) => {
                btn.addEventListener('click', () => {
                    const item = btn.closest('[data-faq-item]');
                    if (!item) return;
                    const open = item.classList.toggle('is-open');
                    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
                });
            });

            // Show more / show less: reveal the extra items.
            const moreBtn = root.querySelector('[data-faq-more]');
            if (moreBtn) {
                const more = moreBtn.dataset.more || moreBtn.textContent.trim();
                const less = moreBtn.dataset.less || 'Show less';
                moreBtn.addEventListener('click', () => {
                    const expanded = root.classList.toggle('is-expanded');
                    moreBtn.textContent = expanded ? less : more;
                    moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                });
            }
        });
    },
};
